import { AdminTask } from 'types';

import { api } from './api';

export const adminTasksApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTaskOptions: build.query<any, { name: AdminTask }>({
      query: ({ name }) => ({
        url: `/admin/tasks/${name}/options`,
      }),
    }),
    runTask: build.mutation<any, any>({
      query: (body) => ({
        url: `/admin/tasks`,
        method: 'POST',
        body,
        responseHandler: (response) => {
          if (body.task === AdminTask.organizationUserExport) {
            return response.blob();
          }
          return response.json();
        },
      }),
    }),
  }),
});

export const { useGetTaskOptionsQuery, useRunTaskMutation } = adminTasksApi;
